import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapperVW'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import MemberCard from 'src/components/molecules/MemberCard'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

import Member1 from 'src/images/top/team/profile_iwakuma.png'
import Member2 from 'src/images/top/team/profile_miyagawa.png'
import Member3 from 'src/images/top/team/profile_yoshida.png'
import { Typography } from 'src/components/atoms/Typography'
import { vwSize } from 'src/utils/vwCss'
import bgImage from 'src/images/top/team/bg.png'

const TEAM = [
  {
    image: Member1,
    name: '岩熊 勇斗',
    position: '執行役員CCO / SuccessHub事業責任者',
    description:
      '新卒でDeNAを経て、クラウドサイン(弁護士ドットコム)に入社。カスタマーサクセス部門の立ち上げおよび責任者を経験し、約5年間で10万社以上の顧客を支援。2020年よりコミューンに参画し、カスタマーサクセス部門責任者として従事したのち執行役員CCO兼SuccessHub事業責任者に就任。幅広い業種・業界のカスタマーサクセスの知見を有す。',
  },
  {
    image: Member2,
    name: '宮川 知也',
    position: 'カスタマーサクセス部　部長',
    description:
      'web広告企業の営業としてキャリアをスタート。toC向けビジネススクールにてコミュニティの立ち上げを、バックオフィスSaaSのCS組織にてチームマネジメントやプロフェッショナルサービスの立ち上げを経験。コミューンではCSMとしてBtoB、BtoC問わず幅広くコミュニティの支援に従事し、現在はカスタマーサクセス部の部長を務める。'
  },
  {
    image: Member3,
    name: '芳田 佳奈',
    position: 'エヴァンジェリスト',
    description:
      '新卒で楽天株式会社に入社し新規営業を担当。その後App Annie Japanにインサイドセールスとして入社、APACのISチームのマネジメントも担う。カスタマーサクセス部門に異動後は日本と東南アジアの顧客を担当。ISマネジャーとしてコミューンに入社。グローバル事業のビジネス領域担当を経て、現在はエヴァンジェリストとして活動。'
  }
]

const TopTeam = () => {
  return (
    <Container>
      <ContentsWrapper>
        <Contents>
          <FadeDownWrap>
            <HeadingBorder heading="TEAMS" />
          </FadeDownWrap>
          <FadeDownWrap>
            <HeadTitle as="h2" className={"g-h2 -mb0"}>カスタマーサクセスに至るチーム体制</HeadTitle>
          </FadeDownWrap>
          <FadeDownWrap>
            <Description css={descriptionCss}>
              貴社・エンドユーザー双方にとって<br className={"pc-none"} />最適なプラットフォーム運営に対し、<br className={"pc-none"} />経験豊富なカスタマーサクセスが<br className={"pc-none"} />真摯に向き合い続けます。
            </Description>
          </FadeDownWrap>
          <Team>
            {TEAM.map((member, i) => (
              <MemberCard {...member} key={i} />
            ))}
          </Team>
        </Contents>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  background-image: url(${bgImage});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    background: none;
  }
`

const Contents = styled.div``

const Description = styled(Typography)`
`

const descriptionCss = css`
  letter-spacing: ${Styles.letterSpacing[400]};
  margin-top: ${vwSize(16, 'pc')}vw;
  font-size: ${Styles.pc.fontSize.text};
  color: ${Styles.pc.color.text};
  line-height: ${Styles.lineHeight[350]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(24, 'sp')}vw;
    font-size: ${Styles.sp.fontSize.text};
    text-align: center;
  }
`

const Team = styled.div`
  margin-top: ${vwSize(60, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(40, 'sp')}vw;
  }
`

export default TopTeam
